import { enumerate } from '/lib/utils';

export default enumerate('SHORT', 'EXTENDED', 'CUSTOM');
